<template>
    <div class="cart-item">
        <div class="w-full md:w-1/3 xl:w-2/5">
            <div v-if="cartItem.categoryLabel" class="text-xs font-semibold pb-xs">
                {{ cartItem.categoryLabel }}
            </div>
            <div class="text-md font-bold text-neutral-darker">
                {{ cartItem.name }}
            </div>
            <div v-if="cartItem.subtitle" class="text-xs text-neutral-medium pt-xs">
                {{ cartItem.subtitle }}
            </div>
        </div>

        <div class="w-full md:w-1/4 xl:w-1/6">
            <span class="md:hidden"> {{ lang('Bindningstid','Binding period') }}: </span>
            {{ cartItem.bindingPeriod }}
        </div>

        <div class="w-full md:w-auto">
            <div v-if="cartItem.monthlyDisplayPrice">{{ cartItem.monthlyDisplayPrice }}</div>
            <div v-if="cartItem.displayPrice" :class="{ 'text-xs mt-xs': cartItem.monthlyDisplayPrice } ">{{ cartItem.displayPrice }}</div>
            <div v-if="! cartItem.monthlyDisplayPrice && ! cartItem.displayPrice">-</div>
        </div>

        <div class="absolute mt-md pin-r md:relative md:mt-0 md:ml-auto">
            <button
                v-if="removeable"
                type="button"
                class="btn btn-icon is-dark text-xs h-2xl w-2xl ml-auto mr-0"
                :aria-label="lang('Ta bort från kundvagn', 'Remove from cart')"
                @click="removeCartItem(cartItem.idHash)"
            >
                <font-awesome-icon icon="trash" />
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            cartItem: {
                type: Object,
                required: true,
            },
            removeable: {
                type: Boolean,
                default: false,
            },

        },

        methods: {
            async removeCartItem(idHash) {
                const response = await axios.delete(route('front.api.cart-items.destroy', idHash));

                this.$emit('cartDataUpdated', response.data);
            },
        },

    };
</script>
